import React from "react";
import SubmittedAgreement from "../../sumitted_agreement/SubmittedAgreement";

const CorrectionFormAgreement = () => {
  const applicationPath = {
    copyright: "/admin/correction-form-copyright",
    agreement: "/admin/correction-form-agreement",
  };
  const pageTitle = "সংরক্ষিত নথি";
  return (
    <SubmittedAgreement
      fileStatus={2}
      applicationPath={applicationPath}
      pageTitle={pageTitle}
    />
  );
};

export default CorrectionFormAgreement;
